/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('power.donut', [
        'https://unpkg.com/chart.js@4.2.0/dist/chart.umd.js',
    ], function (el) {
        var step = new Donut(el);
        step.run();
    });
    var Donut = /** @class */ (function () {
        function Donut(el) {
            this.el = el;
        }
        Donut.prototype.run = function () {
            var values = this.el.dataset.values;
            var jsonBoy = JSON.parse(values);
            var datas = [], colors = [];
            Object.entries(jsonBoy).forEach(function (entry) {
                // @ts-ignore
                var key = entry[0], obj = entry[1];
                // @ts-ignore
                datas.push(obj.value);
                // @ts-ignore
                colors.push(obj.color);
            });
            var data = {
                options: {
                    legend: {
                        display: false,
                    },
                },
                datasets: [{
                        data: datas,
                        backgroundColor: colors,
                        borderWidth: 0,
                        hoverOffset: 2,
                    }],
            };
            var config = {
                type: 'doughnut',
                data: data,
            };
            var ctx = document.getElementById('donutchart');
            new Chart(ctx.getContext('2d'), config);
        };
        return Donut;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
